<template>
  <li v-if="node.name" class="treeNode">
    <div class="node-scope">
      <div class="node-wrap">
        <i
          v-if="node.sub_category && node.sub_category.length"
          class="el-icon-caret-right"
          :class="
            node.sub_category && node.sub_category.length ? activeBtn : ''
          "
          @click.stop="treeToggle"
        ></i>
        <p
          class="node-item"
          :style="indent"
          :class="{
            'node-item-active': !(node.sub_category && node.sub_category.length)
          }"
          @dragstart="dragstart(node)"
          @dragover="dragover($event)"
          @drop="drop(node)"
        >
          <span
            :draggable='true'
            class="omitText"
            @click.stop="treeNodeClick(node)"
            :class="{ activeNameBgd: node.id === Number($route.query.id) }"
          >
            {{ node.name }}
          </span>
        </p>
        <!-- <span class="node-num">{{node.id}}</span> -->
        <p class="add-delete-icon-wrap">
          <i
            class="editor-icon"
            @click.stop="editorNode(node)"
            v-if="!node.parent_id"
          ></i>
          <i class="delete-icon" @click.stop="delNode(node)"></i>
          <i
            class="add-icon"
            @click.stop="addChildNode(node)"
            v-if="node.level !== 3"
          ></i>
        </p>
      </div>
      <el-collapse-transition>
        <ul v-show="chevron">
          <tree-view
            v-if="node.sub_category && node.sub_category.length"
            v-for="(row, idx) in node.sub_category"
            :node="row"
            :index="idx"
            :key="idx"
            :depth="depth + 1"
            @addChildNode="addChildNode"
            @editorNode="editorNode"
            @delNode="delNode"
            @treeNodeClick="treeNodeClick"
            @dragstart="dragstart"
            @drop="drop"
          />
        </ul>
      </el-collapse-transition>
    </div>
  </li>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "treeView",
  props: ["node", "index", "depth"],
  computed: {
    indent() {
      return { width: `${170 - this.depth * 20}px` };
    }
  },
  data() {
    return {
      chevron: true,
      activeBtn: "active-tree-minus"
    };
  },
  methods: {
    treeToggle() {
      this.chevron = !this.chevron;
      this.activeBtn = this.chevron ? "active-tree-minus" : "active-tree-add";
    },
    addChildNode(val) {
      this.$emit("addChildNode", val);
    },
    delNode(val) {
      this.$emit("delNode", val);
    },
    editorNode(val) {
      this.$emit("editorNode", val);
    },
    treeNodeClick(val) {
      this.$emit("treeNodeClick", val);
    },
    dragstart(val) {
      this.$emit("dragstart", val);
    },
    dragover(event) {
      event.preventDefault();
    },
    drop(val) {
      this.$emit("drop", val);
    }
  }
};
</script>

<style lang="scss" src="./index.scss"></style>
